import StepNewFlow from '@/febos/chile/approvals/wizardFlow/wizard/flow/StepNewFlow';
import StepSignaturePosition
from '@/febos/chile/approvals/wizardFlow/wizard/flow/StepSignaturePosition';
import StepFormBuilder from '@/febos/chile/approvals/wizardFlow/wizard/flow/StepFormBuilder';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import {
  mapApprovalActions, mapApprovalSteps
} from '@/febos/chile/approvals/wizardFlow/config/wizard/forms/approvalsCommons';

const hasCompletionStep = (input) => (input.steps || [])
  .some((step) => Number(step.stepType) === StepTypes.COMPLETION);

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Enviar documento a flujo',
      component: StepNewFlow,
      isLazy: true
    },
    {
      title: 'Ubicar firmas del documento',
      component: StepSignaturePosition,
      condition: (input) => input.setSignaturePosition,
      isLazy: true,
      draftOnBack: true
    },
    {
      title: 'Definir campos a completar',
      component: StepFormBuilder,
      condition: hasCompletionStep,
      isLazy: true,
      draftOnBack: true
    }
  ],
  options: ['submit'],
  submitAction: 'sendNewFileFlow',
  loadAllData: false,
  documentMapper(input) {
    const data = {
      adjuntos: [],
      distribucion: (input.distributions || []).map((distribution) => (
        {
          distribucionNombre: distribution.name,
          distribucionCorreo: distribution.mail
        }
      )),
      aprobacionId: input.flowId,
      origen: input.origin,
      ejecucion: {
        privado: input.private ? 'Y' : 'N',
        descripcion: input.description,
        estampar: input.pdfStamp,
        nombre: input.name,
        tipoObjetoCategoria: input.documentType,
        tipoDocumentoId: input.documentTypeId,
        tipoReferencia: 'ARCHIVO',
        aprobacionesReferenciaId: input.flowId,
        precioFlujo: input.amount,
        reversible: true,
        firmaPosicionada: input.setSignaturePosition ? 'Y' : 'N',
        plantilla: {
          aprobaciones: {
            nombre: input.name,
            descripcion: input.description,
            estampar: input.pdfStamp,
            numeroReferencia: 0,
            reversible: true,
            tipoObjeto: input.objectType
          },
          ...mapApprovalSteps(input)
        }
      },
      documentos: [
        {
          adjuntoMime: input.mainFile.mime,
          adjuntoNombre: input.mainFile.name,
          adjuntoUrl: input.mainFile.path,
          fecha: input.mainFile.date,
          objetoId: input.mainFile.id,
          objetoNombre: input.mainFile.name,
          tipoObjetoId: 'ARCHIVO',
          tipoObjetoTexto: 'ARCHIVO - '
        }
      ],
      ...mapApprovalActions(input)
    };
    if (input.oldFlow && input.objectType) {
      data.ejecucion.tipoReferencia = input.objectType;
      data.ejecucion.numeroReferencia = input.number;
    }
    if (input.attachments.length) {
      data.adjuntos = [
        ...data.adjuntos,
        ...(input.attachments || []).map((file) => ({
          adjuntoMime: file.mime,
          adjuntoNombre: file.name,
          adjuntoId: file.id,
          adjuntoEstado: 2,
          fecha: file.date,
          adjuntoUrl: file.path
        }))
      ];
    }
    if (input.consequences.length) {
      data.gatillacionesPreDefinidas = input.consequences;
    }
    if (input.references.length) {
      data.referencias = input.references;
    }
    if (input.fileData && input.origin === 'respuesta') {
      const { metadata } = input.fileData;
      const metaObject = metadata.reduce((acc, meta) => {
        acc[meta.nombre] = meta.valor;
        return acc;
      }, {});
      const { dnt } = input.fileData;
      data.meta = {
        ...metaObject,
        id: (metadata && metadata.find((meta) => meta.nombre === 'ID')?.valor) || '',
        author: input.institutionType,
        matter: input.matter,
        theme: (metadata && metadata.find((meta) => meta.nombre === 'ID_TEMA')?.valor) || '',
        subTheme: (metadata && metadata.find((meta) => meta.nombre === 'ID_SUBTEMA')?.valor) || '',
        documentNumberMother: dnt.numero,
        fechaDocumento: dnt.fechaEmision,
        ...(!!input.relatedDocumentsSelected.length && {
          documentoRelacionados: input.relatedDocumentsSelected
        })
      };
    }
    return data;
  }
});
